import type { EventSink } from '../events'
import { NO_TICK } from '../world'
import type { World } from '../world'
import { endRide } from './rides'

/**
 * Step 8 (pits): falling below `killY` schedules a respawn `respawnDelayTicks` later; the player
 * is frozen and non-colliding until then, then placed at its current checkpoint with
 * post-respawn invulnerability.
 */
export function updateRespawn(world: World, i: number, events: EventSink): void {
  const p = world.players[i]!
  const { cfg, tick } = world
  if (p.respawnAtTick !== NO_TICK) {
    if (tick >= p.respawnAtTick) respawn(world, i, events)
    return
  }
  if (p.y > world.track.killY) {
    endRide(world, i, events)
    p.summonAtTick = NO_TICK
    p.respawnAtTick = tick + cfg.respawnDelayTicks
    p.vx = 0
    p.vy = 0
  }
}

function respawn(world: World, i: number, events: EventSink): void {
  const p = world.players[i]!
  const { cfg, tick } = world
  const cp = world.track.checkpoints[p.checkpoint]!
  p.x = cp.x
  p.y = cp.y
  p.vx = 0
  p.vy = 0
  p.h = cfg.playerHeightPx
  p.grounded = false
  p.jumpsLeft = 1
  p.coyoteUntil = NO_TICK
  p.jumpBufferedUntil = NO_TICK
  p.jumpHeldTicks = 0
  p.invulnUntil = Math.max(p.invulnUntil, tick + cfg.respawnInvulnTicks)
  p.respawnAtTick = NO_TICK
  events.push({ type: 'respawn', tick, player: i, checkpoint: p.checkpoint })
}
